// extracted by mini-css-extract-plugin
module.exports = {"defaultCard":"_l","otherCards":"am","empty":"bm","addNewItem":"cm","disabled":"dm","cardGrid":"em"};